import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { clientSettings } from 'go-modules/models/common/client.settings';

@Injectable({
	providedIn: 'root'
})
export class RubricService {
	constructor (private http: HttpClient) {}

	public saveRubricSessionView (rubricSessionId: number, sessionId: number): Observable<void> {
		return this.http.post<void>(`${clientSettings.GoReactV2API}/submissions/${sessionId}/rubrics/${rubricSessionId}/view`, null);
	}
}
